/**
 * Created by Ning Jiang on 2021-05-05.
 */

import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";

export enum Layers {
    // Layers order from the top to the bottom.
    SCREENS = "screens",
    MINI_PAYTABLE = "mini_paytable",
    SPLASH_VIEW = "splash_view",
    WIN_COUNT_UP = "win_count_up",
    BIG_WIN = "big_win",
    INTRO_VIEW = "intro_view",
    BILLBOARD_VIEW = "billboardView",
    SCATTER_OVERLAY = "scatter_overlay",
    WIN_PRESENTATIONS = "win_presentations",
    SYMBOL_WIN_MULTIPLIER = "symbol_win_multiplier",
    SYMBOL_MULT = "symbolMultiplier",
    HIGH_SYMBOLS_WIN = "high_symbols_win",
    WILD_CONTAINER = "wild_Container",
    REEL_EXPAND_OVERLAY = "reel_overlay",
    REEL_ATTENTION = "reel_attention",
    STICKY_LAYER = "stickyLayer",
    SCATTER_BELOW = "scatter_below_sticky",
    LOW_SYMBOLS_WIN = "low_symbols_win",
    LOW_SYMBOLS = "low_symbols",
    FOREGROUND = "foreground",
    ENHANCED_BUTTON = "enhanced",
    REEL_BACKGROUND = "reel_background",
    BACKGROUND = "background",
}

export class SimpleStageLayer extends PIXI.Container implements StageLayer {

    constructor() {
        super();
    }

    // Note: these only check the direct children.
    public onResize(): void {
        this.children.forEach((child: any) => {
            if (child.onResize) {
                child.onResize();
            }
        });
    }

    public onOrientationChanged(): void {
        this.children.forEach((child: any) => {
            if (child.onOrientationChanged) {
                child.onOrientationChanged();
            }
        });
    }
}

export class KarenLayers {

    constructor() {
        for (const key in Layers) {
            NolimitApplication.addLayerAt((<any>Layers)[key], new SimpleStageLayer(), 0);
        }
    }

    public static getLayer(name: string): StageLayer | undefined {
        return NolimitApplication.getLayerByName(name);
    }
}
